import { render } from "./index.vue?vue&type=template&id=493164ca&ts=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=ts&generic=T%20extends%20CappedStackItem&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&generic=T%20extends%20CappedStackItem&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__